import Reveal from '@/components/base/Reveal';
import { timelineEvents } from '@/mocks/homeData';

export default function TimelineSection() {
  return (
    <section id="timeline" className="border-y border-background-200/80 bg-background-100">
      <div className="mx-auto w-full max-w-shell px-4 py-20 md:px-6 md:py-28">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-16">
          <div className="lg:col-span-4">
            <Reveal>
              <span className="inline-flex items-center gap-2 rounded-full border border-secondary-300/70 bg-secondary-50 px-3 py-1 text-xs font-medium text-secondary-800">
                <i className="ri-history-line" />
                事件时间线
              </span>
              <h2 className="mt-5 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
                按发生顺序往下读，前因后果自然连起来
              </h2>
              <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
                每个话题都有一条自己的时间线。新节点会续写在原来的位置上，你不需要记住自己上次看到哪，
                顺着往下补就行。
              </p>
              <div className="mt-8 rounded-lg border border-background-300/70 bg-background-50 p-5">
                <p className="font-label text-xs font-medium tracking-wide text-foreground-500">当前话题</p>
                <p className="mt-2 font-heading text-base font-semibold text-foreground-950">
                  #古装新剧花絮 · 从首图到归档
                </p>
                <div className="mt-4 flex items-center gap-3 text-xs text-foreground-600">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-node-tree text-sm text-secondary-600" />
                    6 个关键节点
                  </span>
                  <span className="flex items-center gap-1.5">
                    <i className="ri-time-line text-sm text-secondary-600" />
                    跨度约 11 小时
                  </span>
                </div>
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-8">
            <ol className="relative border-l border-background-300/80 pl-6 md:pl-10">
              {timelineEvents.map((event, index) => (
                <li key={event.time} className="relative pb-10 last:pb-0">
                  <span className="absolute -left-[32px] top-1 flex h-4 w-4 items-center justify-center rounded-full border-2 border-background-100 bg-accent-500 md:-left-[48px]">
                    <span className="h-1.5 w-1.5 rounded-full bg-background-50" />
                  </span>
                  <Reveal delay={index * 70}>
                    <div className="flex flex-wrap items-center gap-3">
                      <span className="font-heading text-lg font-bold text-foreground-950">{event.time}</span>
                      <span className="inline-flex items-center rounded-full bg-accent-100 px-2.5 py-0.5 text-xs font-medium text-accent-900">
                        {event.tag}
                      </span>
                    </div>
                    <div className="mt-3 rounded-lg border border-background-200/80 bg-background-50 p-4 md:p-5">
                      <h3 className="text-sm font-semibold text-foreground-950 md:text-base">{event.title}</h3>
                      <p className="mt-2 text-sm leading-relaxed text-foreground-600">{event.text}</p>
                    </div>
                  </Reveal>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}